/**
 * Shared scroll config for dashboard tables.
 *
 * antd v3 tables need an explicit scroll.x to render a horizontal scrollbar
 * when column widths exceed the viewport. `x: true` does not account for
 * CSS min-widths on columns, so fixed numeric values (e.g. 1280/1400) and
 * `true` both fail on smaller laptops / Windows 125-150% scaling.
 * `'max-content'` sizes the table to its natural content width and scrolls
 * only when needed, leaving wide-desktop rendering unchanged.
 */
export const RESPONSIVE_TABLE_SCROLL = {
  x: 'max-content',
  scrollToFirstRowOnChange: true,
}

/**
 * Drop columns marked `hideBelow` on narrow viewports so important data and
 * actions fit without horizontal scrolling. Wide screens are unaffected.
 *
 * Usage: give a column `hideBelow: 1280` to hide it below 1280px, then pass
 * the array through: columns={filterResponsiveColumns(columns, windowWidth)}
 */
export const filterResponsiveColumns = (columns, windowWidth) =>
  (columns || [])
    .filter(Boolean)
    .filter(column => !column.hideBelow || windowWidth >= column.hideBelow)
    .map(column => {
      const rest = { ...column }
      delete rest.hideBelow
      return rest
    })
